import events from 'ui-addon-upgrades/events.yaml';
import { createTracker } from 'usage-tracker';
import { Tracker } from 'usage-tracker-core';
import { isApiBlackListed } from '../navigation/isApiBlackListed';

type EventProperties = Parameters<Tracker['track']>[1];

const AMPLITUDE_APP_NAME = 'upgrades';

export const tracker = createTracker({
  events,
  properties: {
    namespace: AMPLITUDE_APP_NAME,
  },
});

const _cleanUpEventProperties = (
  eventProperties: EventProperties
): EventProperties => {
  if (!eventProperties) return {};
  Object.keys(eventProperties).forEach((property) => {
    if (
      eventProperties[property] === null ||
      eventProperties[property] === undefined
    ) {
      delete eventProperties[property];
    }
  });
  return eventProperties;
};

export const track = (eventKey: string, eventProperties?: EventProperties) => {
  if (isApiBlackListed()) {
    return;
  }

  const cleanedUpEventProperties = _cleanUpEventProperties(eventProperties);
  tracker.track(eventKey, cleanedUpEventProperties);
};
